import { generateErrors, isFeatureEnabled } from 'utilities/util';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { TYPES } from 'action-types/historyLog';
import { callApiGet, callApiV3Post, callApiV3Get, callApiV2Get} from 'utilities/apiCaller';
import API from 'constants/api';
import { getType } from '../utilities/util';
import { TransportMode } from 'constants/modes';
import { IStore } from 'reducers/index';
import { FEATURE_TOGGLES } from 'constants/featureToggles';


export const fetchHistoryLog = (shipmentId: string, shipmentType: any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.FETCH_HISTORY_LOG.PENDING });
        try {
            const res = await callApiV2Get(API.HistoryLogs.HistoryLogs, { 'shipmentId': shipmentId, 'shipmentType': getType(shipmentType) }, {});
            dispatch({ type: TYPES.FETCH_HISTORY_LOG.FULFILLED, response: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_HISTORY_LOG.REJECTED, errors });
        }
    }
};

export const fetchHistoryLogCostAndRevenue = (shipmentId: string, shipmentType: string | number) => {
  if(shipmentType === 'ets') {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.FETCH_HISTORY_CV_LOG.PENDING });
        try {
            const res = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_WEBAPI_IMPORT_CHARGE_ITEMS_AUDIT_LOG, getState().featureToggle.featureToggles)
                ? await callApiV2Get(`${API.CostRevenueNew.ImportChargeItemsAuditLogs(shipmentId)}`)
                : await callApiV3Post(API.HistoryLogs.GetHistoryLogCostAndRevenueByShipmentId, { 'SearchId': shipmentId, 'Level': shipmentType }, { });
            dispatch({ type: TYPES.FETCH_HISTORY_CV_LOG.FULFILLED, costAndRevenue: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_HISTORY_CV_LOG.REJECTED, errors });
        }
    }
    } else {
        return async (dispatch: ThunkDispatch<any, any, Action>) => {
            dispatch({ type: TYPES.FETCH_HISTORY_CV_LOG.PENDING });
            try {
                const res = await callApiV3Get(`${API.HistoryLogs.GetHistoryLogCostAndRevenueByShipmentIdNew}?searchId=${shipmentId}&level=${shipmentType}`, {}, { headers: { TransportMode: TransportMode.Ocean } })
                dispatch({ type: TYPES.FETCH_HISTORY_CV_LOG.FULFILLED, costAndRevenue: res.data })
            } catch (e) {
                const errors = generateErrors(e);
                dispatch({ type: TYPES.FETCH_HISTORY_CV_LOG.REJECTED, errors });
            }
        }
    }
};

export const fetchBlob = (id: string, isReprocess:boolean = false) => {
    const url = isReprocess? `${API.HistoryLogs.GetBlobReprocess}${id}`: `${API.HistoryLogs.GetBlob}${id}`
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_HISTORY_BLOB.PENDING });
        try {
            const res = await callApiV3Get(url);
            dispatch({ type: TYPES.FETCH_HISTORY_BLOB.FULFILLED, blob: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_HISTORY_BLOB.REJECTED, errors });
        }
    }
};

export const fetchBlobFileUpload = (id: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_HISTORY_BLOB.PENDING });
        try {
			const res = await callApiV3Get(`${API.HistoryLogs.GetBlobBulkUpload}${id}`, {format: 'json'}, { headers: { TransportMode: TransportMode.Ocean } });
			dispatch({ type: TYPES.FETCH_HISTORY_BLOB.FULFILLED, blob: res.data });			
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_HISTORY_BLOB.REJECTED, errors });
        }
    }
};

export const fetchOutputFile = (id: string) => {
	return (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
		dispatch({ type: TYPES.FETCH_OUTPUT_FILE.PENDING });
		return new Promise((resolve, reject) => {
			callApiV3Get(
				`${API.HistoryLogs.GetBlobBulkUpload}${id}`,
				{format: 'excel'},
				{
					headers: {
						'Content-Type': 'blob',
						TransportMode: TransportMode.Ocean
					},
					responseType: 'arraybuffer',
				},
			)
				.then((res) => {
					const fileName = 'Report';
					dispatch({ type: TYPES.FETCH_OUTPUT_FILE.FULFILLED, outputBlob: res.data, outputFileName: fileName });
					resolve({outputBlob: res.data, outputFileName: fileName});
				})
				.catch((e) => {
					const errors = generateErrors(e);
					dispatch({ type: TYPES.FETCH_OUTPUT_FILE.REJECTED, errors });
					reject('Error fetching ouput file');
				});
		});
	};
};

export const fetchBlobFileDownload = (id: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_HISTORY_BLOB.PENDING });
        try {
            const res = await callApiGet(`${API.ETS.DownloadFileSummary}/${id}`, {}, { headers: { TransportMode: TransportMode.Ocean } });
            dispatch({ type: TYPES.FETCH_HISTORY_BLOB.FULFILLED, blob: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_HISTORY_BLOB.REJECTED, errors });
        }
    }
};